import { observer } from 'mobx-react';
import { FormItemText, Input } from 'top-component-library';

interface TextInputProps {
  autoComplete?: string;
  className?: string;
  id?: string;
  initialValue?: string;
  inlineLabel?: string;
  inputTestId?: string;
  placeholder?: string;
  label?: string;
  name?: string;
  required?: boolean;
  testId?: string;
  validationMessage?: string;
  maxLengthMessage?: string;
  max?: number | null;
  maxLength?: number | null;
  onFocus?: null;
  'aria-label'?: string;
}

const TextInput = ({
  autoComplete = '',
  className = '',
  id = '',
  initialValue = '',
  inlineLabel = '',
  inputTestId = '',
  placeholder = '',
  label = '',
  name = '',
  required = true,
  testId = '',
  validationMessage = '',
  maxLengthMessage = '',
  max = null,
  maxLength = null,
  onFocus = null,
  'aria-label': ariaLabel = '',
}: TextInputProps) => (
  <FormItemText
    className={`${inlineLabel ? 'inline-label' : ''} ${className}`}
    id={id}
    initialValue={initialValue}
    data-testid={testId}
    label={inlineLabel || label}
    name={name}
    rules={[
      {
        required,
        message: validationMessage || 'This is a required field',
        transform: (value) => value?.trim(),
      },
      {
        // maxLengthMessage will render when characters inputted exceed ${max} and will block submit
        // Use ${maxLength} to block typing once ${maxLength} is hit. This will NOT render the maxLengthMessage.
        max,
        message: maxLengthMessage || `Cannot exceed ${max} characters`,
      },
    ]}
    validateTrigger={['onBlur', 'onChange']}
  >
    <Input
      data-testid={inputTestId}
      type="text"
      autoComplete={autoComplete || (name === 'name' ? 'given-name' : name)}
      placeholder={placeholder}
      onFocus={onFocus}
      maxLength={maxLength}
      aria-label={ariaLabel}
    />
  </FormItemText>
);

export default observer(TextInput);
